import Header from "./Header";
import Footer from "./Footer";
import { useLenis } from "../lib/useLenis";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./Loader";
import { MessageCircle, Instagram } from "lucide-react";
import { company } from "../data/site";

export default function Layout({ children }) {
  useLenis();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="min-h-screen bg-[#FAFAFA] grain relative">
      <Loader />
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      {/* Floating social actions */}
      <div className="fixed z-40 bottom-6 right-6 flex flex-col gap-3">
        <a
          data-testid="floating-whatsapp"
          href={company.whatsapp}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          className="w-11 h-11 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_16px_32px_-8px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform"
        >
          <MessageCircle size={18} />
        </a>
        <a
          data-testid="floating-instagram"
          href={company.social.instagram}
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
          className="w-11 h-11 rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] text-white grid place-items-center shadow-[0_16px_32px_-8px_rgba(220,39,68,0.4)] hover:scale-110 transition-transform"
        >
          <Instagram size={18} />
        </a>
      </div>
    </div>
  );
}
